import React, { useState, useEffect, Fragment, useRef } from 'react';
import groupService from '../../../Group/services';
import service from '../service';
import InputLabel from '@material-ui/core/InputLabel';
import Select from '@material-ui/core/Select';
import { TotalCropReportTable } from "../../../Common/Table/tableContent";
import MenuItem from '@material-ui/core/MenuItem';
import { Pagination, PageHeader, paginate } from '../../../../Common';
import Joi from '@hapi/joi';
import { validateProperty, validate } from "../../../Common";
import { Grid } from '@material-ui/core';
import TextField from '@material-ui/core/TextField';
import FormHelperText from '@material-ui/core/FormHelperText';
import "react-datepicker/dist/react-datepicker.css";
import { totalCropReportSchema } from "../totalCropReportSchema";
import { LoadingSpinerComponent } from '../../../../Common/loader'
import { trackPromise } from 'react-promise-tracker';
import authService from '../../../Common/services';
import tokenService from '../../../../Common/tokenDecoder';
import '../../../Common/Table/table.css';
import TablePagination from '@material-ui/core/TablePagination';
import Chip from '@material-ui/core/Chip';
import moment from 'moment';
import xlsx from 'json-as-xlsx';
import CreatePDF from './createPdf';
import ReactToPrint from "react-to-print";
import Divider from '@material-ui/core/Divider';
import Typography from '@material-ui/core/Typography';
import Box from '@material-ui/core/Box';
import MaterialTable, { MTableBody } from "material-table";
import _, { flatMap } from 'lodash';
import $ from 'jquery';

const screenCode = 'TOTALCROPREPORT'

export function TotalCropReport(props) {

    const componentRef = useRef();

    const [groups, setGroups] = useState([]);
    const [operationEntity, setOperationEntity] = useState([]);
    const [collectionPoint, setCollectionPoint] = useState([]);
    const [collectionCategory, setCollectionCategory] = useState([]);
    const [isTableHide, setIsTableHide] = useState(true);
    const [searchData, setsearchData] = useState({
        groupID: "0",
        operationEntityID: "0",
        collectionPointID: "0",
        month: ""
    });
    const [errors, setErrors] = useState({});
    const schema = Joi.object(totalCropReportSchema).options({ allowUnknown: true });
    const [data, setdata] = useState([]);
    const [csvData, setCsvData] = useState([]);
    const DropdownChanges = Object.freeze({ "group": 1, "operationEntity": 2 })
    const [reportData, setReportData] = useState([]);
    const [isViewTable, setIsViewTable] = useState(true);
    const [columeNames, setColumeNames] = useState([]);
    const [allTotal, setAllTotal] = useState([]);
    const [total, setTotal] = useState(0);
    const [permissionList, setPermissions] = useState({
        isGroupFilterEnabled: false,
        isOperationEntityFilterEnabled: false
    });
    const inishialColumName = [{
        title: 'Date', field: 'weightReadTime', render: rowData => rowData.weightReadTime, headerStyle: {
            color: '#000000',
            textAlign: 'center',
            fontWeight: 'bold'
        }, cellStyle: { textAlign: 'left' }

    }]
    const [contentRowNames, setContentRowNames] = useState([]);
    const [csvHeaders, setCsvHeaders] = useState([]);
    const [selectedSearchValues, setSelectedSearchValues] = useState({
        group: "",
        estate: "",
        collectionID: "",
        month: "",
    });

    useEffect(() => {
        trackPromise(
            getPermissions()
        )
    }, [])

    useEffect(() => {
        trackPromise(
            getOperationEntities()
        )
    }, [searchData.groupID])

    useEffect(() => {
        trackPromise(
            getCollectionPointsForDropDown()
        )
        checkDisbursement();
    }, [searchData.operationEntityID])

    async function getPermissions() {
        var permissions = await authService.getPermissionsByScreen(screenCode);
        var isAuthorized = permissions.find(p => p.permissionCode == 'VIEWTOTALCROPREPORT');

        if (isAuthorized === undefined) {
            props.history.push('/unauthorized');
        }
        var isGroupFilterEnabled = permissions.find(p => p.permissionCode == 'GROUPDROPDOWN');

        var isOperationEntityFilterEnabled = permissions.find(p => p.permissionCode == 'OPERATIONENTITYDROPDOWN');
        setPermissions({
            ...permissionList,

            isGroupFilterEnabled: isGroupFilterEnabled !== undefined,
            isOperationEntityFilterEnabled: isOperationEntityFilterEnabled !== undefined
        });

        var token = tokenService.getUserDetailsFromToken();
        setsearchData({
            ...searchData,
            groupID: token.groupID,
            operationEntityID: token.operationEntityID
        });

        getGroupsForDropDown();
    }

    async function getGroupsForDropDown() {
        const groupsList = await groupService.getGroupsForDropdown();
        setGroups(groupsList);
    }

    async function getOperationEntities() {
        const operationEntityList = await service.getOperationEntitiesByGroupForDropDown(searchData.groupID);
        setOperationEntity(operationEntityList);
    }

    async function getCollectionPointsForDropDown() {
        const collectionPoint = await service.getCollectionPointsByOperationentityGroupID(searchData.operationEntityID, searchData.groupID);
        setCollectionPoint(collectionPoint);
    }

    function handleChange(e) {
        e.preventDefault();

        const target = e.target;
        const value = target.value;

        const error = { ...errors };
        const errorMessage = validateProperty(target, totalCropReportSchema);
        errorMessage ? error[target.name] = errorMessage : delete error[target.name];

        setsearchData({
            ...searchData,
            [e.target.name]: value
        });

        setErrors(error);
    }
    async function handleSearch(e) {

        setIsTableHide(true);
        const errorMessages = validate(schema, searchData);
        errorMessages !== null ? setErrors(errorMessages) : setErrors({});
        if (errorMessages) return;

        setIsViewTable(true);
        const reportData = await service.GetTotalCropReport(searchData.operationEntityID, searchData.collectionPointID, searchData.month);

        var contentRowNamesArray = [];
        contentRowNamesArray.push("weightReadTime");
        contentRowNamesArray.push("collectionPointName");

        var csvHeaders = [
            { label: "Date", value: "weightReadTime", render: rowData => rowData.weightReadTime.split("T")[0] },
            { label: "Collection Point Name", value: "collectionPointName" }
        ];

        var copyOfColumes = inishialColumName;

        var uniqDates = [];
        reportData.forEach(x => {
            uniqDates.push(x.collectionTypeName)
        })

        setSelectedSearchData();
        uniqDates = [...new Set(uniqDates)];

        var formattedResut = formatResult(reportData);

        var copyOfColumes = inishialColumName;

        uniqDates.forEach(x => {
            contentRowNamesArray.push(x);
            csvHeaders.push({
                label: x, value: x
            })
            copyOfColumes.push({
                title: x, field: x, render: rowData => !isNaN(rowData[x]) ? parseFloat(rowData[x]).toFixed(2) : rowData[x]
                , headerStyle: {
                    color: '#000000',
                    textAlign: 'center',
                    fontWeight: 'bold'
                }, cellStyle: { textAlign: 'right' }
            });

            formattedResut.result.forEach(y => {

                if (y[x] === undefined || y[x] === "") {
                    y[x] = "-";
                }

            })
        });

        contentRowNamesArray.push("total");
        csvHeaders.push({ label: "Total", value: "total" });
        copyOfColumes.push({
            title: "Total", field: "total", render: rowData => parseFloat(rowData.total).toFixed(2)
            , headerStyle: {
                color: '#000000',
                textAlign: 'center',
                fontWeight: 'bold'
            }, cellStyle: { textAlign: 'right' }
        });

        setColumeNames(copyOfColumes);
        setContentRowNames(contentRowNamesArray);
        setReportData(formattedResut.result);
        setCsvHeaders(csvHeaders);
        generateCsvData(formattedResut);
        setIsTableHide(false);
        createDataTable(contentRowNamesArray, ["#totalCrop", "#totalCropPdf"]);

    }


    function generateCsvData(data) {

        var newRecord = {};
        var copyOfRecords = _.cloneDeep(data.result);

        newRecord.weightReadTime = "Total";
        data.totalResult.forEach(x => {
            newRecord[x.name] = x.value
        });

        copyOfRecords.push(newRecord);

        setCsvData(copyOfRecords);
    }

    function formatResult(data) {
        var result = [];
        var totalOfAllrecords = 0;
        var totalRow = [];

        data.forEach(x => {
            var collectionTypeName = (x.collectionTypeName);

            if (result.length === 0) {
                result.push({
                    collectionPointName: x.collectionPointName,
                    [collectionTypeName]: parseFloat(x.grossAmount) === 0 ? "" : parseFloat(x.grossAmount),
                    total: parseFloat(x.grossAmount),
                    weightReadTime: x.weightReadTime.split("T")[0],
                });
                totalOfAllrecords = totalOfAllrecords + parseFloat(x.grossAmount);
                totalRow.push({ name: x.collectionTypeName, value: parseFloat(x.grossAmount).toFixed(2) });
            } else {
                var duplicateDate = result.find(y => (y.weightReadTime) === (x.weightReadTime.split("T")[0])
                    && y.collectionPointName === x.collectionPointName);
                totalOfAllrecords = totalOfAllrecords + parseFloat(x.grossAmount);

                var duplicateTotalRowData = totalRow.find(y => y.name === x.collectionTypeName);

                if (duplicateTotalRowData) {
                    duplicateTotalRowData.value = (parseFloat(duplicateTotalRowData.value) + parseFloat(x.grossAmount)).toFixed(2);
                } else {
                    totalRow.push({ name: x.collectionTypeName, value: parseFloat(x.grossAmount).toFixed(2) });
                }

                if (duplicateDate) {
                    duplicateDate[collectionTypeName] = parseFloat(x.grossAmount) === 0 ? "" : parseFloat(x.grossAmount);
                    duplicateDate.total = parseFloat(duplicateDate.total) + parseFloat(x.grossAmount);
                } else {
                    result.push({
                        collectionPointName: x.collectionPointName,
                        [collectionTypeName]: parseFloat(x.grossAmount) === 0 ? "" : parseFloat(x.grossAmount),
                        total: parseFloat(x.grossAmount),
                        weightReadTime: x.weightReadTime.split("T")[0],
                    });
                }
            }
        });

        totalRow.push({ name: "total", value: totalOfAllrecords.toFixed(2) });

        setAllTotal(totalRow);

        return {
            result: result,
            totalResult: totalRow
        };
    }
    function createDataTable(contentResult, dataTables) {
        dataTables.forEach(x => {
            $(x).DataTable({
                order: [[1, "asc"]],
                destroy: x === '#totalCropPdf' ? true : false,
                searching: x === '#totalCropPdf' ? false : true,
                paging: x === '#totalCropPdf' ? false : true,
                scrollX: false,
                rowGroup: {
                    startRender: null,
                    endRender: function (rows, group) {

                        var dynamicCountVariable = [];

                        for (var i = 0; i < contentResult.length; ++i) {
                            if (i > 1) {
                                dynamicCountVariable[i] = rows
                                    .data()
                                    .pluck(i)
                                    .reduce(function (a, b) {
                                        var calResult = checkUndifined(a) + checkUndifined(b) * 1
                                        return calResult;
                                    }, 0);
                            }
                        }

                        var rowData = '';

                        for (var i = 0; i < contentResult.length; ++i) {
                            if (i > 1) {
                                rowData += '<td style="text-align:right"><b>' + dynamicCountVariable[i].toFixed(2) + '</b></td>';
                            }
                        }


                        return $('<tr/>')
                            .append('<td colspan="2"><b>Total for ' + group + '</b></td>')
                            .append(rowData);
                    },
                    dataSrc: 1
                }
            })
        });
    }

    function checkUndifined(value) {
        if (value === undefined || value === NaN || value === "-") {
            return 0;
        } else {
            return value;
        }
    }

    function setSelectedSearchData() {
        setSelectedSearchValues({
            ...selectedSearchValues,
            group: groups[searchData.groupID],
            estate: operationEntity[searchData.operationEntityID],
            collectionID: collectionPoint[searchData.collectionPointID],
            month: searchData.month
        })
    }

    function checkDisbursement() {
        if (searchData.month === '') {
            setIsViewTable(true);
        }
        else {
            setIsViewTable(false);
        }
    }

    function generateDropDownMenu(data) {
        let items = []
        if (data != null) {
            for (const [key, value] of Object.entries(data)) {
                items.push(<MenuItem key={key} value={key}>{value}</MenuItem>);
            }
        }
        return items
    }

    function createFile() {
        var settings = {
            sheetName: 'Total Crop Report',
            fileName: 'Total Crop Report',
            writeOptions: {}
        }

        xlsx(csvHeaders, csvData, settings, true)
    }


    return (
        <Fragment>
            <LoadingSpinerComponent />
            <div className="row">
                <div className="card">
                    <div className="card-body" id="startPoint">
                        <div className="row">
                            <PageHeader
                                title="Total Crop Report"
                            />
                        </div>
                        <form>
                            <div className="form-group row">
                                <div className="col-md pb-1">
                                    <InputLabel shrink id="groupID">Group *</InputLabel>
                                    <Select
                                        fullWidth
                                        id="groupID"
                                        name="groupID"
                                        disabled={!permissionList.isGroupFilterEnabled}
                                        value={searchData.groupID}
                                        onChange={(e) => handleChange(e)}>
                                        <MenuItem value="0">--Select Group--</MenuItem>
                                        {generateDropDownMenu(groups)}
                                    </Select>
                                    {errors["groupID"] && <FormHelperText id="errbranchCode" className="text text-danger">{errors["groupID"]}</FormHelperText>}
                                </div>

                                <div className="col-md pb-1">
                                    <InputLabel shrink id="operationEntityID">Factory *</InputLabel>
                                    <Select
                                        fullWidth
                                        id="operationEntityID"
                                        name="operationEntityID"
                                        disabled={!permissionList.isOperationEntityFilterEnabled}
                                        value={searchData.operationEntityID}
                                        onChange={(e) => handleChange(e)}>
                                        <MenuItem value="0">--Select Factory--</MenuItem>
                                        {generateDropDownMenu(operationEntity)}
                                    </Select>
                                    {errors["operationEntityID"] && <FormHelperText id="errbranchCode" className="text text-danger">{errors["operationEntityID"]}</FormHelperText>}
                                </div>

                                <div className="col-md pb-1">
                                    <InputLabel shrink id="collectionPointID">Collection point</InputLabel>
                                    <Select
                                        fullWidth
                                        id="collectionPointID"
                                        name="collectionPointID"
                                        value={searchData.collectionPointID}
                                        onChange={(e) => handleChange(e)}>
                                        <MenuItem value="0">--Select Collection point--</MenuItem>
                                        {generateDropDownMenu(collectionPoint)}
                                    </Select>
                                    {errors["collectionPointID"] && <FormHelperText id="errbranchCode" className="text text-danger">{errors["collectionPointID"]}</FormHelperText>}
                                </div>

                                <div className="col-md pb-1">
                                    <TextField
                                        id="month"
                                        label="month *"
                                        name="month"
                                        type="month"
                                        fullWidth
                                        value={searchData.month}
                                        onChange={(e) => handleChange(e)}
                                        InputLabelProps={{
                                            shrink: true,
                                        }}
                                    />
                                    {errors["month"] && <FormHelperText id="errbranchCode" className="text text-danger">{errors["month"]}</FormHelperText>}
                                </div>
                            </div>
                            <div className="form-group row">
                                <div className="col-md pb-1">
                                    <input
                                        type="button"
                                        className="btn btn-primary"
                                        value="Generate"
                                        onClick={e => trackPromise(handleSearch(e))}
                                    />
                                </div>
                            </div>
                            {isTableHide ? null :
                                <Grid item md={12} xs={12}>
                                    <table id="totalCrop">
                                        <thead>
                                            <tr>
                                                {contentRowNames.map((x, index) => {
                                                    let result = x.replace(/([A-Z])/g, " $1");
                                                    let finalResult = result.charAt(0).toUpperCase() + result.slice(1);
                                                    if (finalResult === "Weight Read Time") {
                                                        finalResult = "Date";
                                                    }
                                                    return (
                                                        <th key={index}>{finalResult}</th>
                                                    );
                                                })}
                                            </tr>
                                        </thead>
                                        <tbody>
                                            <TotalCropReportTable
                                                data={reportData}
                                                contentRowNames={contentRowNames}
                                                hasEdit={false}
                                            />
                                        </tbody>
                                        <tfoot>
                                            <tr>
                                                <td style={{ fontWeight: "bold", textAlign: "left" }}>TOTAL</td>
                                                <td></td>
                                                {columeNames.map(x => {
                                                    var result = allTotal.find(y => y.name === x.field);

                                                    if (result) {
                                                        return (
                                                            <td style={{ textAlign: "end", fontWeight: "bold" }}>{result.value}</td>
                                                        );
                                                    }

                                                })}
                                            </tr>
                                        </tfoot>
                                    </table>
                                </Grid>
                            }
                        </form>
                        {
                            (reportData.length == 0 || reportData == undefined || reportData == null || reportData == []) ?
                                null : <div className="pt-3">
                                    <ReactToPrint
                                        trigger={() => <input
                                            type="button"
                                            className="btn btn-primary pull-right ml-2"
                                            value="Create PDF"
                                        />}
                                        content={() => componentRef.current}
                                        documentTitle={'Total Crop Report'}
                                    />
                                    <div hidden={true}>
                                        <CreatePDF ref={componentRef} data={reportData} rowNames={contentRowNames}
                                            searchData={selectedSearchValues} totalRow={allTotal} columeNames={columeNames}/>
                                    </div>
                                    <input
                                        type="button"
                                        className="btn btn-primary pull-right ml-2"
                                        value="Excel"
                                        onClick={createFile}
                                    />
                                </div>
                        }
                    </div>
                </div>
            </div>
        </Fragment >
    );
}



